import { DeliverySlotWindow } from '@lyka-pet-food/contracts'
import { z } from 'zod'

export const UserSchema = z.object({
  cognitoUserId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phoneNumber: z.string(),
  tenantType: z.enum(['LykaStaff', 'D2cCustomer', 'Guest']).optional(),
})

export type User = z.infer<typeof UserSchema>
export const AddressSchema = z.object({
  addressId: z.string(),
  cognitoUserId: z.string(),
  isDefault: z.boolean(),
  address1: z.string(),
  address2: z.string(),
  suburb: z.string(),
  city: z.string(),
  state: z.enum(['VIC', 'NSW', 'ACT', 'NT', 'QLD', 'SA', 'TAS', 'WA']),
  postCode: z.string(),
  countryCode: z.string(),
  deliveryInstructions: z.string(),
  companyName: z.string(),
})

export type Address = z.infer<typeof AddressSchema>

export const PutDefaultAddressSchema = AddressSchema.omit({
  cognitoUserId: true,
  isDefault: true,
}).extend({
  date: z
    .object({
      deliveryDate: z.string(),
      deliverySlotId: z.nativeEnum(DeliverySlotWindow),
    })
    .optional(),
})

export type PutDefaultAddress = z.infer<typeof PutDefaultAddressSchema>

export const PatchUserSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  phoneNumber: z
    .string()
    .regex(/^(\+61|0)[2-478](\d{8})$/, 'Invalid Australian phone number') // Validate Australian phone numbers
    .optional(),
  password: z
    .string()
    .min(6, 'Password must be at least 6 characters long') // Enforce minimum length of 6 characters
    .optional(),
})

export type PatchUser = z.infer<typeof PatchUserSchema>

export const PhoenixMigrateAndAuthenticateBodySchema = z.object({
  email: z.string().email(),
  password: z.string(),
})

export type PhoenixMigrateAndAuthenticateBody = z.infer<
  typeof PhoenixMigrateAndAuthenticateBodySchema
>

export const PasswordChangeResponseSchema = z.object({
  success: z.boolean(),
  accessToken: z.string().optional(),
  refreshToken: z.string().optional(),
})

export type PasswordChangeResponse = z.infer<typeof PasswordChangeResponseSchema>
